import { useFormikContext } from "formik";
import { useEffect } from "react";
import { customerKindEnum, customerTypeEnum } from "../../../utils";

export const SetIndividualHandler = () => {
  const { values, setFieldValue }: any = useFormikContext();

  useEffect(() => {
    if (
      values.customerTypeId === customerTypeEnum.real &&
      values.customerKindId === customerKindEnum.indivual
    ) {
      setFieldValue("contact.identityNo", values.citizenOrTaxNumber, true);
      setFieldValue("contact.name", values.name, true);
      // setFieldValue("contact.surname", values.surname, true);
      setFieldValue("contact.dateOfBirth", values.dateOfBirth, true);
    }

    // if (values.customerKindId !== customerKindEnum.corporate) {
    //   setFieldValue(`contact.contactCommunication.0.value`, values.email);
    // }

    setFieldValue(
      `contact.isBlueCardCitizen`,
      values.customerDetail?.isBlueCardCitizen
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default SetIndividualHandler;
